let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bykog")).then(() => parcelRequire('aV6Us'));